import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { BrandProfileResource } from 'dy-frontend-http-repository/lib/modules/BrandProfile/resources';
import domain from './domain';
import { resetClientBrandProfiles } from './events';

// Brand profile
export const $clientBrandProfiles = domain
    .createStore<CollectionResource<BrandProfileResource, {}> | null>(null)
    .reset(resetClientBrandProfiles);
